var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuickactionscustomerTransfer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10614_87881)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#ECF3FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3333 17.875C24.6785 17.875 24.9583 18.1548 24.9583 18.5C24.9583 22.0702 22.0702 24.9583 18.5 24.9583C18.2748 24.9583 18.0671 24.8372 17.9561 24.6413C17.8452 24.4453 17.8482 24.2049 17.9641 24.0118L18.8391 22.5534C19.0166 22.2575 19.4006 22.1615 19.6965 22.3391C19.9925 22.5167 20.0885 22.9006 19.9109 23.1966L19.6848 23.5734C21.9924 23.038 23.7083 20.9722 23.7083 18.5C23.7083 18.1548 23.9882 17.875 24.3333 17.875Z",
    fill: "#174EA9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3155 8.42663C10.0079 8.96199 8.29199 11.0279 8.29199 13.5C8.29199 13.8452 8.01217 14.125 7.66699 14.125C7.32181 14.125 7.04199 13.8452 7.04199 13.5C7.04199 9.92984 9.93015 7.04169 13.5003 7.04169C13.7255 7.04169 13.9333 7.16281 14.0442 7.35875C14.1551 7.55469 14.1521 7.79516 14.0363 7.98824L13.1613 9.44658C12.9837 9.74257 12.5998 9.83855 12.3038 9.66096C12.0078 9.48336 11.9118 9.09945 12.0894 8.80346L12.3155 8.42663Z",
    fill: "#174EA9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.0003 19.0833V19.5917H7.66699V19.0833C7.66699 17.6167 8.03366 17.25 9.51699 17.25H14.1503C15.6337 17.25 16.0003 17.6167 16.0003 19.0833Z",
    fill: "#174EA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66699 19.5917V20.8417V22.5C7.66699 23.9667 8.03366 24.3333 9.51699 24.3333H14.1503C15.6337 24.3333 16.0003 23.9667 16.0003 22.5V20.8417V19.5917H7.66699Z",
    fill: "#174EA9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.3333 9.50002V10.0084H16V9.50002C16 8.03335 16.3667 7.66669 17.85 7.66669H22.4833C23.9667 7.66669 24.3333 8.03335 24.3333 9.50002Z",
    fill: "#174EA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.0084V11.2584V12.9167C16 14.3834 16.3667 14.75 17.85 14.75H22.4833C23.9667 14.75 24.3333 14.3834 24.3333 12.9167V11.2584V10.0084H16Z",
    fill: "#174EA9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10614_87881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickactionscustomerTransfer);
export default __webpack_public_path__ + "static/media/quickactions[customer-transfer].84942ebb.svg";
export { ForwardRef as ReactComponent };